<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useSettingsApi } from '../../api/settings/get.hook'
import BannerConfigVault from './BannerConfigVault.vue'
import TableSettings from './TableSettings.vue'

defineOptions({
  name: 'SettingsPage',
})

onMounted(() => {
  void useSettingsApi()
})

useOnTimezoneChange(() => {
  void useSettingsApi()
})
</script>

<template>
  <BannerConfigVault />
  <TableSettings />
</template>
